import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});

export class DirectionFetchAPI {
    static async getDirectionById(direction_id, token) {
        const res = await server(`/direction?direction_id=${direction_id}`, {
            method: "get",
            headers: {'x-access-token': token},
        });
        return res
    }

    
}